import { FilterGroup, IFilters } from 'types';
import { FilterGroupComponent } from './FilterGroup';
import { Accordion } from '@chakra-ui/react';

export interface IProps {
  filters: IFilters;
  filterGroups: FilterGroup[];
  openFilterSetup: (filterKey: string) => void;
  filterGroupExpanded: (groupName: string, expanded: boolean) => void;
}

export const Content = (props: IProps) => {
  const { filters, openFilterSetup, filterGroups, filterGroupExpanded } = props;

  const defaultIndexes = filterGroups
    .filter(filterGroup => filters?.expanded?.includes(filterGroup?.name))
    .map((_, index) => index);

  const handleExpandedFilter = (expandedIndex: Array<number>) => {
    filterGroups.forEach((filterGroup, index) => {
      if (expandedIndex.includes(index)) {
        filterGroupExpanded(filterGroup.name, true);
      } else {
        filterGroupExpanded(filterGroup.name, false);
      }
    });
  };

  return (
    <Accordion variant="rounded" allowMultiple onChange={handleExpandedFilter} defaultIndex={defaultIndexes}>
      {filterGroups.map(group => (
        <FilterGroupComponent
          key={`FilterOption-${group.name}`}
          filtergroup={group}
          openFilterSetup={openFilterSetup}
          filters={filters}
        />
      ))}
    </Accordion>
  );
};
